export const releaseDetail = {
    version: '4.7.1',
    date: '05/14/2026',
}